import React from "react";
import { MainLeftTitle } from "../../../_uiComponents/WrapperComponents";
import RetailActivationReportGrid from "./views/RetailActivationReportGrid";

export default function RetailActivationReportWrapper() {
     return (
          <>
               <MainLeftTitle title="New Car Sales Activation Report" />

               <RetailActivationReportGrid />
          </>
     );
}
